/* =====================================================
   AYAANI MOBILE DRAWER – FINAL JS
   ✔ Level 1 : Base menu
   ✔ Level 2 : Absolute drawer overlay
   ✔ Level 3 : ALWAYS VISIBLE (NO ACCORDION)
   ✔ Clean, simple, stable
===================================================== */

(() => {
  /* ---------------- SAFE DOM READY ---------------- */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  function init() {
    /* ---------------- ELEMENTS ---------------- */
    const drawer = document.getElementById("AyaaniDrawer");
    if (!drawer) return;

    const level2List = drawer.querySelector("#AyaaniLevel2");
    const closeBtns = drawer.querySelectorAll("[data-ay-close]");
    const backBtn = drawer.querySelector("[data-ay-back]");
    const menuJSON = document.getElementById("AyaaniMenuJSON");

    let menuData = [];
    try {
      menuData = JSON.parse(menuJSON.textContent || "{}").items || [];
    } catch (e) {
      console.error("AyaaniDrawer: Invalid menu JSON");
      return;
    }

    /* ---------------- STATE ---------------- */
    const setLevel = (level) => {
      drawer.classList.toggle("is-level-2", level === 2);
    };

    /* ---------------- OPEN / CLOSE ---------------- */
    const openDrawer = () => {
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("aydrawer-lock");
      setLevel(1);
    };

    const closeDrawer = () => {
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("aydrawer-lock");
      setLevel(1);
      level2List.innerHTML = "";
    };

    /* ---------------- DAWN HEADER TRIGGER ---------------- */
    document.addEventListener(
      "click",
      (e) => {
        const summary = e.target.closest("#header-drawer summary");
        if (!summary) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const details = summary.closest("details");
        if (details && details.hasAttribute("open")) {
          details.removeAttribute("open");
        }

        openDrawer();
      },
      true
    );

    /* ---------------- CLOSE HANDLERS ---------------- */
    closeBtns.forEach((btn) =>
      btn.addEventListener("click", closeDrawer, { passive: true })
    );

    backBtn?.addEventListener("click", () => setLevel(1));

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") {
        closeDrawer();
      }
    });

    /* ---------------- LEVEL 1 → LEVEL 2 ---------------- */
    drawer.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-open-level2]");
      if (!btn) return;

      const index = Number(btn.dataset.openLevel2);
      const item = menuData[index];
      if (!item) return;

      /* 👉 SET BACK TITLE = PARENT MENU NAME */
      const backTitle = drawer.querySelector(".aydrawer__back-title");
      if (backTitle) {
        backTitle.textContent = item.title; // Ring / Earrings / etc
      }

      // Safety: no children → navigate
      if (!item.children || item.children.length === 0) {
        window.location.href = item.url;
        return;
      }

      /* -------- Render Level-2 + Level-3 (always open) -------- */
      let html = "";

      item.children.forEach((child) => {
        html += `
          <li class="aydrawer__item">
            <div class="aydrawer__row">
              <span>${child.title}</span>
            </div>
        `;

        if (child.children && child.children.length > 0) {
          html += `
            <ul class="aydrawer__level3" style="transform:none; opacity:1; max-height:none;">
              ${child.children
              .map(
                (g) => `
                <li class="aydrawer__item">
                  <a class="aydrawer__row " href="${g.url}">
                    <span>${g.title}</span>
                  </a>
                </li>`
              )
              .join("")}
            </ul>
          `;
        }

        html += `</li>`;
      });

      level2List.innerHTML = html;
      setLevel(2);
    });
  }
})();